var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 426,
    viewBox: "0 0 426 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.144 0H263.711V20.2834H243.428V40.5668H202.855V101.432H162.288V81.1427H182.571V20.2834H223.144V0Z",
    fill: "#0A65A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V142.001H142.001V0H0ZM121.713 121.713H20.288V20.288H121.713V121.713Z",
    fill: "#0A65A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.001 0V142.001H425.994V0H284.001ZM405.706 121.713H304.289V20.288H405.714V121.713H405.706Z",
    fill: "#0A65A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5684 40.5669H101.428V101.426H40.5684V40.5669Z",
    fill: "#0A65A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.562 40.5669H385.421V101.426H324.562V40.5669Z",
    fill: "#0A65A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.145 60.8589H243.428V81.1423H223.145V60.8589Z",
    fill: "#0A65A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.424 81.144H263.708V162.288H243.424V121.712H223.141V142.002H202.852V101.435H243.424V81.144Z",
    fill: "#0A65A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.289 121.712H182.572V142.002H202.856V162.288H182.572V202.855H202.856V182.572H223.145V162.288H243.428V223.145H202.856V243.428H182.572V223.145H162.289V182.572H121.713V162.288H162.289V121.712Z",
    fill: "#0A65A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5684 162.288H81.1352V182.577H40.5684V162.288Z",
    fill: "#0A65A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.705 162.288H304.281V182.571H283.998V202.854H263.705V162.288Z",
    fill: "#0A65A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.562 162.288H344.851V182.577H324.562V162.288Z",
    fill: "#0A65A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 182.569H40.5668V202.853H60.8593V223.142H40.5668V243.426H20.2834V202.853H0V182.569Z",
    fill: "#0A65A4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1455 182.569H121.712V202.853H101.429V223.142H121.712V243.426H81.1455V182.569Z",
    fill: "#0A65A4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.85 182.569H365.143V202.853H385.426V263.709H365.143V243.426H324.561V263.709H304.283V223.142H344.85V182.569Z",
    fill: "#0A65A4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.713 202.849H141.996V223.139H121.713V202.849Z",
    fill: "#0A65A4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M405.704 202.849H425.994V223.139H405.704V202.849Z",
    fill: "#0A65A4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142 223.145H162.287V263.711H121.711V243.428H142V223.145Z",
    fill: "#0A65A4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M243.425 223.145H263.714V243.428H243.425V223.145Z",
    fill: "#0A65A4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 243.425H20.2834V263.715H0V243.425Z",
    fill: "#0A65A4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5684 243.425H60.8518V263.715H40.5684V243.425Z",
    fill: "#0A65A4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.849 243.425H243.422V263.709H223.139V304.285H202.849V344.851H182.566V304.285H162.282V263.709H182.566V283.995H202.849V243.425Z",
    fill: "#0A65A4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.705 243.425H283.995V263.715H263.705V243.425Z",
    fill: "#0A65A4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M405.704 243.425H425.994V263.715H405.704V243.425Z",
    fill: "#0A65A4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.425 263.706H263.714V304.272H243.425V263.706Z",
    fill: "#0A65A4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344.85 263.706H365.139V304.272H344.85V263.706Z",
    fill: "#0A65A4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M385.426 263.706H405.709V283.989H385.426V263.706Z",
    fill: "#0A65A4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.282 283.994H324.559V304.283H344.848V344.85H405.702V365.133H324.557V405.703H304.28V365.133H283.997V385.426H263.704V405.703H283.997V425.993H182.564V405.703H243.421V365.133H263.704V304.283H304.28L304.282 283.994Z",
    fill: "#0A65A4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 283.994V425.994H142.001V283.994H0ZM121.713 405.706H20.288V304.289H121.713V405.706Z",
    fill: "#0A65A4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M223.145 304.282H243.428V324.566H223.145V304.282Z",
    fill: "#0A65A4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M365.146 304.282H405.706V324.566H365.146V304.282Z",
    fill: "#0A65A4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5684 324.562H101.428V385.421H40.5684V324.562Z",
    fill: "#0A65A4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M405.704 324.562H425.994V344.851H405.704V324.562Z",
    fill: "#0A65A4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.288 344.85H182.571V365.133H202.855V385.426H162.288V344.85Z",
    fill: "#0A65A4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.85 344.85H243.416V365.133H202.85V344.85Z",
    fill: "#0A65A4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M365.146 385.426H385.429V405.709H365.146V385.426Z",
    fill: "#0A65A4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M405.704 385.426H425.994V405.709H405.704V385.426Z",
    fill: "#0A65A4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M324.562 405.706H344.851V425.996H324.562V405.706Z",
    fill: "#0A65A4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.8a7ab10bfd39d16e6f1fa5ff73408e36.svg";
export { ForwardRef as ReactComponent };